import { z } from 'zod';

// Ein Orakel-Block: Objekt mit variablen Feldern. Die AUSWAHL der Blöcke ist
// typisiert und explizit; die Blockinhalte bleiben Orakel-Form (nicht vertraglich
// fixiert — volle Durchtypisierung wäre fragil und brächte nichts).
const OracleBlockSchema = z.record(z.string(), z.unknown());
const OracleListSchema = z.array(z.unknown());

export const McpBriefingContextSchema = z
  .object({
    account_360: z
      .object({
        account: OracleBlockSchema.optional(),
        kpis: OracleBlockSchema.optional(),
        contacts: OracleListSchema.optional(),
        opportunities: OracleListSchema.optional(),
        projects: OracleListSchema.optional(),
        consultants: OracleListSchema.optional(),
      })
      .optional(),
    opportunity: z
      .object({
        opportunity: OracleBlockSchema.optional(),
        staffing: OracleListSchema.optional(),
        line_items: OracleListSchema.optional(),
        projects: OracleListSchema.optional(),
      })
      .optional(),
    documents: z
      .array(
        z.object({
          title: z.string(),
          doc_type: z.string().optional(),
          url: z.string().optional(),
          snippet: z.string(),
        }),
      )
      .optional(),
    synthesis: z.string().optional(),
    sourcesUsed: z.array(z.string()),
  })
  .nullable();

export const MissionBriefingInputSchema = z.object({
  project_key: z.string(),
  project_name: z.string(),
  customer_name: z.string(),
  segment: z.string(),
  intake_handover_fields: z.unknown().optional(),
  handover_ready_fields: z.unknown().optional(),
  auftraege: z.array(
    z.object({
      project_key: z.string(),
      name: z.string(),
      customer_name: z.string(),
      kind: z.string(),
      segment: z.string().nullable().optional(),
      ms_classification: z.string().nullable().optional(),
      responsibility: z.string().nullable().optional(),
      sf_budget_eur: z.string().nullable().optional(),
      salesforce_data: z.unknown().optional(),
    }),
  ),
  mcp_context: McpBriefingContextSchema.optional(),
});

export const MissionBriefingLlmOutputSchema = z.object({
  body: z.string().min(1),
});

export type MissionBriefingInput = z.infer<typeof MissionBriefingInputSchema>;
export type McpBriefingContext = z.infer<typeof McpBriefingContextSchema>;
export type MissionBriefingLlmOutput = z.infer<typeof MissionBriefingLlmOutputSchema>;
